import { render } from "./DetailsBox.vue?vue&type=template&id=28e2bf9d&scoped=true&lang=pug"
import script from "./DetailsBox.vue?vue&type=script&lang=js"
export * from "./DetailsBox.vue?vue&type=script&lang=js"

import "./DetailsBox.vue?vue&type=style&index=0&id=28e2bf9d&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e2bf9d"]])

export default __exports__